import { combineReducers } from "redux";

// Front
import LayoutReducer from "./other/layouts/reducer";

import authSlice from "../slices/apps/authSlice";
import customerSlice from "./apps/customerSlice";
import packageSlice from "./apps/packageSlice";
import agreementSlice from "./apps/agreementSlice";
import paymentSlice from "./apps/paymentSlice";
import settingSlice from "./apps/settingSlice";

const rootReducer = combineReducers({
  Layout: LayoutReducer,

  auth: authSlice,
  agreement: agreementSlice,
  customer: customerSlice,
  package: packageSlice,
  payment: paymentSlice,
  setting: settingSlice,
});

export default rootReducer;
